import { render, staticRenderFns } from "./gasDetailDialog.vue?vue&type=template&id=0b9f734c&"
import script from "./gasDetailDialog.vue?vue&type=script&lang=js&"
export * from "./gasDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports